export interface DTFSettings {
	/** Identifiant du tenant (marque blanche) */
	tenantId: string;
	/** Largeur du film (laize) en cm */
	laizeCm: number;
	/** Hauteur maximale d'une planche en cm */
	maxPlancheCm: number;
	/** Hauteur de départ d'une planche en cm (palier) */
	minPlancheCm: number;
	/** Prix au cm linéaire */
	prixCmLineaire: number;
	/** Minimum de facturation sur la commande complète */
	minCommande: number;
	/** Espacement entre les logos en mm (les bords de planche sont flush, sans marge) */
	margeMm: number;
	devise: string;
	/** TVA en % (CH 8.1, FR 20, DE 19, IT 22, ES 21, PT 23) */
	tvaPct: number;
	/** true : les prix affichés sont TTC */
	prixTtc: boolean;
	/** Taille maximale d'un fichier importé, en Mo */
	maxFichierMb: number;
	langue: string;
}

export const DEFAULT_SETTINGS: DTFSettings = {
	tenantId: 'dtfswiss',
	laizeCm: 55,
	maxPlancheCm: 100,
	minPlancheCm: 50,
	prixCmLineaire: 0.24,
	minCommande: 12,
	margeMm: 5,
	devise: 'CHF',
	tvaPct: 8.1,
	// tarif de base HT : 12 CHF la planche 55×50 = minimum HORS taxe (Daniel, 2026-08-16)
	prixTtc: false,
	maxFichierMb: 30,
	langue: 'fr',
};

const STORAGE_KEY = 'dtf_v2_settings';

export function loadSettings(): DTFSettings {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw) {
			return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
		}
	} catch (_e) {
		// ignore
	}
	return { ...DEFAULT_SETTINGS };
}

export function saveSettings(s: DTFSettings): void {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
	} catch (_e) {
		// ignore
	}
}
